module.exports = __webpack_public_path__ + "img/background.7e07d22f.png";